import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bf3c72a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf3c72a')) {
      api.createRecord('6bf3c72a', component.options)
    } else {
      api.reload('6bf3c72a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bf3c72a", function () {
      api.rerender('6bf3c72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/appmenu/index.vue"
export default component.exports